import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom"
import JournalEntries from "./pages/JournalEntries";
import Dashboard from "./Dashboard";
import Layout from "./Layout";
import JournalItems from "./pages/JournalItems";
import ChartsOfAccounts from "./pages/ChartsOfAccounts";
import AddAccount from "./pages/AddAccount";
import { loadAccounts, loadOneAccount } from "./apis/accountAPI";
import EditAccount from "./pages/EditAccount";
import Journals from "./pages/Journals";
import AddJournals from "./pages/AddJournals";
import { loadJournals, loadJournalTypes } from "./apis/jounalAPI";
import { loadJournalEntry, loadJournalItems, loadJournalItemsType } from "./apis/journalEntriesAPI";
import IncomeStatements from "./pages/IncomeStatements";
import Taxes from "./pages/Taxes";
import Assets from "./pages/Assets";
import AssetChanges from "./pages/AssetChanges";
import { loadAccountAndSetup, loadAssets } from "./apis/assetAPI";
import TaxChanges from "./pages/TaxChages";
import { loadTax, loadTaxes } from "./apis/taxesAPI";
import DeferredRevenues from "./pages/DeferredRevenues";
import { loadDeferredRevenueAndSetup, loadDeferredRevenues } from "./apis/DeferredRevenueAPI";
import DeferredRevenueChanges from "./pages/DeferredRevenueChanges";
import FinancialReports from "./pages/FinancialReports";
import { loadFinancialReport, loadGeneralLedger, loadJournalReport, loadPartnerLedgerReport, loadTrialBalance } from "./apis/reportAPI";
import DeferredExpense from "./pages/DeferredExpense";
import DeferredExpenseChanges from "./pages/DeferredExpenseChanges";
import { loadDeferredExpenseAndSetup, loadDeferredExpenses } from "./apis/deferredExpenseAPI";
import CustomerInvoices from "./pages/CustomerInvoices";
import CustomerInvoiceChanges from "./pages/CustomerInvoiceChanges";
import { loadCustomerInvoice, loadCustomerInvoices } from "./apis/customerInvoiceAPI";
import VendorBills from "./pages/VendorBills";
import { loadBills, loadOneBill } from "./apis/vendorBillAPI";
import VendorBillChanges from "./pages/VendorBillChanges";
import BudgetaryPositions from "./pages/BudgetaryPositions";
import { loadBudgetaryPosition, loadBudgetaryPositions } from "./apis/budgetaryPositionAPI.js";
import BudgetaryPositionChanges from "./pages/BudgetaryPositionChanges";
import Budgets from "./pages/Budgets.js";
import { loadBudget, loadBudgets } from "./apis/budgetsAPI.js";
import BudgetChanges from "./pages/BudgetChanges.js";
import AnalyticAccounts from "./pages/AnalyticAccounts.js";
import { loadAnalyticAccount, loadAnalyticAccounts } from "./apis/analyticAccountAPI.js";
import AnalyticAccountChanges from "./pages/AnalyticAccountChanges.js";
import AnalyticItems from "./pages/AnalyticItems.js";
import { loadAnalyticItem, loadAnalyticItems } from "./apis/AnalyticItemAPI.js";
import AnalyticItemChanges from "./pages/AnalyticItemChanges.js";
import InvoiceCreditNotes from "./pages/InvoiceCreditNotes.js";
import { loadCreditNote, loadCreditNotes } from "./apis/creditNotesAPI.js";
import InvoiceCreditNotesChanges from "./pages/InvoiceCreditNoteChanges.js";
import VendorDebitNotes from "./pages/VendorDebitNotes.js";
import { loadDebitNote, loadDebitNotes } from "./apis/debitNoteAPI.js";
import VendorDebitNoteChanges from "./pages/VendorDebitNoteChanges.js";
import AnalyticPlans from "./pages/AnalyticPlans.js";
import { loadAnalyticPlan, loadAnalyticPlans } from "./apis/AnalyticPlanAPI.js";
import AnalyticPlanChanges from "./pages/AnalyticPlanChanges.js";
import AnalyticDistributionModels from "./pages/AnalyticDistributionModels.js";
import { loadDistributionModel, loadDistributionModels } from "./apis/analyticDistributionModelAPI.js";
import AnalyticDistributionModelChanges from "./pages/AnalyticDistributionModelChanges.js";
import Settings from "./pages/Settings.js";
import JournalReports from "./pages/JournalReports.js";
import Tags from "./pages/Tags.js";
import TagChanges from "./pages/TagChanges.js";
import { loadTag, loadTags } from "./apis/tagAPI.js";
import TaxReports from "./pages/TaxReports.js";
import Payments from "./pages/Payments.js";
import { loadPayment, loadPayments } from "./apis/paymentAPI.js";
import PaymentChanges from "./pages/PaymentChanges.js";
import GeneralLegder from "./pages/GeneralLedger.js";
import { loadSettings } from "./apis/settingAPI.js";
import TrialBalance from "./pages/TrialBalance.js";
import PartnerLedgerReport from "./pages/PartnerLedgerReport.js";
import JournalItemsType from "./pages/JournalItemsType.js";






const financeRouter = () => (
  <Route path="/accounting" element={<Layout />}>
    <Route index element={<Dashboard />} />
    <Route path="journals" element={<Journals />} loader={loadJournals} />
    <Route path="journals/:action" element={<AddJournals />} loader={parmas => loadJournalTypes(parmas.params.action)} />
    <Route path="journal-entries/:action" element={<JournalEntries />} loader={params => loadJournalEntry(params.params.action)} />
    <Route path="journal-items" element={<JournalItems />} loader={loadJournalItems} />
    <Route path="journal-items/:type" element={<JournalItemsType />} loader={params => loadJournalItemsType(params.params.type)} />
    <Route path="accounts" element={<ChartsOfAccounts />} loader={loadAccounts} />
    <Route path="accounts/:action" element={<AddAccount />} loader={params => loadOneAccount(params.params.action)}/>
    {/* <Route path="accounts/update/:id" element={<EditAccount />} loader={params => loadOneAccount(params.params.id)} /> */}
    <Route path="taxes" element={<Taxes />} loader={loadTaxes} />
    <Route path="taxes/:action" element={<TaxChanges />} loader={params => loadTax(params.params.action)} />
    <Route path='assets' element={<Assets />} loader={loadAssets} />
    <Route path="assets/:action" element={<AssetChanges />} loader={params => loadAccountAndSetup(params.params.action)} />
    <Route path="deferred-revenues" element={<DeferredRevenues />} loader={loadDeferredRevenues}/>
    <Route path="deferred-revenues/:action" element={<DeferredRevenueChanges />} loader={params => loadDeferredRevenueAndSetup(params.params.action)}/>
    <Route path="deferred-expenses" element={<DeferredExpense />} loader={loadDeferredExpenses}/>
    <Route path="deferred-expenses/:action" element={<DeferredExpenseChanges />} loader={params => loadDeferredExpenseAndSetup(params.params.action)}/>
    <Route path="report/:id" element={<FinancialReports />} loader={params => loadFinancialReport(params.params.id)}/>
    <Route path="invoices" element={<CustomerInvoices />} loader={loadCustomerInvoices} />
    <Route path="invoices/:action" element={<CustomerInvoiceChanges /> } loader={params => loadCustomerInvoice(params.params.action)} />
    <Route path="bills" element={<VendorBills />} loader={loadBills} />
    <Route path="bills/:action" element={<VendorBillChanges />} loader={params => loadOneBill(params.params.action)} />
    <Route path="budgetary-positions" element={<BudgetaryPositions />} loader={loadBudgetaryPositions} />
    <Route path="budgetary-positions/:action" element={<BudgetaryPositionChanges />} loader={params => loadBudgetaryPosition(params.params.action)} />
    <Route path="budgets" element={<Budgets />} loader={loadBudgets} />
    <Route path="budgets/:action" element={<BudgetChanges />} loader={params => loadBudget(params.params.action)} />
    <Route path="analytic-accounts" element={<AnalyticAccounts />} loader={loadAnalyticAccounts} />
    <Route path="analytic-accounts/:action" element={<AnalyticAccountChanges />} loader={params => loadAnalyticAccount(params.params.action)} />
    <Route path="analytic-items" element={<AnalyticItems />} loader={loadAnalyticItems} />
    <Route path="analytic-items/:action" element={<AnalyticItemChanges />} loader={params => loadAnalyticItem(params.params.action)} />
    <Route path="credit-notes" element={<InvoiceCreditNotes />} loader={loadCreditNotes} />
    <Route path="credit-notes/:action" element={<InvoiceCreditNotesChanges />} loader={params => loadCreditNote(params.params.action)} />
    <Route path="debit-notes/" element={<VendorDebitNotes />} loader={loadDebitNotes} />
    <Route path="debit-notes/:action" element={<VendorDebitNoteChanges />} loader={params=> loadDebitNote(params.params.action)} />
    <Route path="analytic-plans" element={<AnalyticPlans />} loader={loadAnalyticPlans} />
    <Route path="analytic-plans/:action" element={<AnalyticPlanChanges />} loader={params => loadAnalyticPlan(params.params.action)} />
    <Route path="analytic-distribution-models" element={<AnalyticDistributionModels />} loader={loadDistributionModels} />
    <Route path="analytic-distribution-models/:action" element={<AnalyticDistributionModelChanges />} loader={params => loadDistributionModel(params.params.action)} />
    <Route path="tags" element={<Tags />} loader={loadTags} />
    <Route path="tags/:action" element={<TagChanges />} loader={params => loadTag(params.params.action)} />
    <Route path=":partner_type/payments" element={<Payments />} loader={params => loadPayments(params.params.partner_type)} />
    <Route path=":partner_type/payments" element={<Payments />} loader={params => loadPayments(params.params.partner_type)} />
    <Route path="payments/:action" element={<PaymentChanges />} loader={parmas => loadPayment(parmas.params.action)} />
    <Route path="bills/:number/:action" element={<PaymentChanges />} loader={parmas => loadPayment(parmas.params.action)} />

    <Route path="journal-report" element={<JournalReports />} loader={loadJournalReport} />
    <Route path="tax-report" element={<TaxReports />} />
    <Route path="general-ledger-report" element={<GeneralLegder />} loader={loadGeneralLedger} />
    <Route path="trial-balance" element={<TrialBalance />} loader={loadTrialBalance} />
    <Route path="report/partner-ledger" element={<PartnerLedgerReport />} loader={loadPartnerLedgerReport} />
    <Route path="settings" element={<Settings />} loader={loadSettings} />
  </Route>
);

export default financeRouter;